import React from "react";
import { Image, ArrowUpRight } from "lucide-react";
import Scrap3 from "../Images/Scrap3.png";
import almuniumscrap from "../Images/almuniumscrap.png";
import copperscrap from "../Images/copperscrap.png";
import Heavymetalic from "../Images/Heavymetalic.png";
import IronRod from "../Images/IronRod.png";
import idustrialScrap from "../Images/idustrialscrap.png";
import { useNavigate } from "react-router-dom";
const Gallery = () => {
  const navigate=useNavigate();
  const galleryItems = [
    {
      id: 1,
      title: "Iron Scrap Collection",
      category: "Iron Scrap",
      image: IronRod,
      path:'/IronScrapsection'
    },
    {
      id: 2,
      title: "Copper Scrap Processing",
      category: "Copper",
      image: copperscrap,
      path:'/copperScrap'
    },
    {
      id: 3,
      title: "Industrial Scrap Yard",
      category: "Industrial",
      image: idustrialScrap,
      path:'/AluminiumScrap'
    },
    {
      id: 4,
      title: "Aluminum Recycling",
      category: "Aluminum",
      image: almuniumscrap,
      path:'/CarScrap'
    },
    {
      id: 5,
      title: "Heavy Machinery",
      category: "Equipment",
      image: Heavymetalic,
      path:'/IronScrapsection'
    },
    {
      id: 6,
      title: "Scrap Loading Process",
      category: "Operations",
      image: Scrap3,
      path:'/PlasticScrap'
    },
  ];

  const styles = {
    section: {
      padding: "100px 20px",
      background:
        "linear-gradient(135deg,#f8faff 0%,#eef3ff 100%)",
      fontFamily: "'Poppins', sans-serif",
    },

    container: {
      maxWidth: "1300px",
      margin: "0 auto",
    },

    headingBox: {
      textAlign: "center",
      marginBottom: "60px",
    },

    heading: {
      fontSize: "48px",
      fontWeight: "700",
      color: "#0B2E7A",
      marginTop: "15px",
      marginBottom: "15px",
    },

    subHeading: {
      maxWidth: "700px",
      margin: "0 auto",
      color: "#666",
      lineHeight: "1.8",
    },

    grid: {
      display: "grid",
      gridTemplateColumns:
        "repeat(auto-fit,minmax(320px,1fr))",
      gap: "25px",
    },

    card: {
      position: "relative",
      overflow: "hidden",
      borderRadius: "25px",
      height: "320px",
      cursor: "pointer",
      boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
    },

    image: {
      width: "100%",
      height: "100%",
      objectFit: "cover",
    },
  };

  return (
    <>
      <style>
        {`
          .gallery-card{
            transition:.5s ease;
          }

          .gallery-card:hover{
            transform:translateY(-10px);
            box-shadow:0 25px 60px rgba(11,46,122,.18);
          }

          .gallery-image{
            transition:.7s ease;
          }

          .gallery-card:hover .gallery-image{
            transform:scale(1.12);
          }

          .gallery-overlay{
            position:absolute;
            inset:0;
            background:linear-gradient(
              to top,
              rgba(11,46,122,.92),
              rgba(11,46,122,.15)
            );
            display:flex;
            flex-direction:column;
            justify-content:flex-end;
            padding:25px;
            color:#fff;
            transition:.4s;
          }

          .gallery-content{
            transform:translateY(30px);
            transition:.4s ease;
            opacity:.8;
          }

          .gallery-card:hover .gallery-content{
            transform:translateY(0);
            opacity:1;
          }

          .gallery-badge{
            display:inline-block;
            background:#fff;
            color:#0B2E7A;
            padding:6px 14px;
            border-radius:30px;
            font-size:12px;
            font-weight:600;
            margin-bottom:12px;
          }

          .gallery-title{
            font-size:24px;
            font-weight:700;
            margin-bottom:10px;
          }

          .gallery-icon{
            width:45px;
            height:45px;
            border-radius:50%;
            background:#fff;
            color:#0B2E7A;
            display:flex;
            align-items:center;
            justify-content:center;
            transition:.4s;
          }

          .gallery-card:hover .gallery-icon{
            transform:rotate(45deg);
          }

          .gallery-heading{
            display:inline-block;
            transition:.4s;
            cursor:pointer;
          }

          .gallery-heading:hover{
            transform:scale(1.05);
          }

          .gallery-main-icon{
            animation:floatIcon 3s ease-in-out infinite;
          }

          @keyframes floatIcon{
            0%{transform:translateY(0)}
            50%{transform:translateY(-10px)}
            100%{transform:translateY(0)}
          }

          @media(max-width:768px){
            .gallery-heading{
              font-size:34px !important;
            }
          }
        `}
      </style>

      <section style={styles.section}>
        <div style={styles.container}>
          <div style={styles.headingBox}>
            <Image
              size={30}
              color="#0B2E7A"
              className="gallery-main-icon"
            />

            <h2
              className="gallery-heading"
              style={styles.heading}
            >
              Our Gallery
            </h2>

            <p style={styles.subHeading}>
              Explore our scrap collection, recycling
              operations, machinery, processing units and
              successful projects.
            </p>
          </div>

          <div style={styles.grid}>
            {galleryItems.map((item) => (
              <div
                key={item.id}
                className="gallery-card"
                style={styles.card}
              >
                <img
                  src={item.image}
                  alt={item.title}
                  className="gallery-image"
                  style={styles.image}
                />

                <div className="gallery-overlay">
                  <div className="gallery-content">
                    <div className="gallery-badge">
                      {item.category}
                    </div>

                    <h3 className="gallery-title">
                      {item.title}
                    </h3>

                    <div onClick={()=>navigate(item.path)} className="gallery-icon">
                      <ArrowUpRight size={20} />
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default Gallery;